import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select, { components } from 'react-select'
import { Footer, Header } from './headerFooter';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { getHost } from './config';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";

const RentPrices = () => {
    const [data, setData] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [uniqueLocations, setUniqueLocations] = useState([]);
    const [sortBy, setSortBy] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc'); // ascending order by default
    const navigate = useNavigate();
    const token = localStorage.getItem('authToken');

    useEffect(() => {
        if (!token) {
            navigate('/', { replace: true });
        }
    }, [token, navigate]);

    const handleLogout = () => {
        // Clear the authToken from localStorage
        localStorage.removeItem('authToken');
        localStorage.setItem('logout-event', Date.now());

        // Redirect to the login page
        navigate('/', { replace: true });
    }

    useEffect(() => {
        // Fetch data from the backend
        const url = `${getHost()}/api/rent-prices`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        })
            .then(response => response.json())
            .then(data => {
                setData(data.results);
                setFilteredData(data.results);
                const locations = [...new Set(data.results.map(item => item['Περιοχή']))];
                setUniqueLocations(locations.map(location => ({ value: location, label: location })));
            });
    }, []);

    useEffect(() => {
        if (selectedRegions.length === 0) {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item => selectedRegions.some(region => region.value === item['Περιοχή']));
            setFilteredData(filtered);
        }
    }, [selectedRegions, data]);

    const handleRegionChange = (selectedOptions) => {
        setSelectedRegions(selectedOptions);
    };

    const handleSort = (column) => {
        const order = column === sortBy && sortOrder === 'asc' ? 'desc' : 'asc';
        setSortBy(column);
        setSortOrder(order);
        const sortedData = [...filteredData].sort((a, b) => {
            if (order === 'asc') {
                return a[column] - b[column];
            } else {
                return b[column] - a[column];
            }
        });
        setFilteredData(sortedData);
    };

    // Custom Option component to add checkboxes
    const Option = (props) => {
        return (
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                    style={{
                        marginRight: 10,
                        accentColor: props.isSelected ? 'white' : 'initial', // Change color when selected
                    }}
                />{' '}
                <label>{props.label}</label>
            </components.Option>
        );
    };

    // Custom styles for react-select components
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#4caf50' : state.isFocused ? '#f0f0f0' : 'white',
            color: state.isSelected ? 'white' : 'black',
            boxShadow: state.isFocused ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none',
            '&:hover': {
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Add light shadow on hover
            },
        }),
        control: (provided) => ({
            ...provided,
            borderColor: '#ccc',
            '&:hover': {
                borderColor: '#b3b3b3',
            },
        }),
        checkbox: (provided) => ({
            ...provided,
            backgroundColor: 'black', // Change checkbox color to black
        }),
    };

    
    return (
        <div id="root">
            <Header handleLogout={handleLogout}/>
            <main className='main-container'>
                <Container className='custom-container'>
                    {data ? (
                        <div className="mb-3 pt-3">                        
                            <div className='table-outer-wrapper pb-3'>
                                <div className="table-scroll-wrapper">
                                    <Table striped hover className='table-primary'>
                                        <thead>
                                            <tr>
                                                <th className="sortable" onClick={() => handleSort("Περιοχή")}>Περιοχή</th>
                                                <th className="sortable" onClick={() => handleSort("Β' τρίμηνο 2025 (€/τμ)")}>Β' τρίμηνο 2025 (€/τμ)</th>
                                                <th className="sortable" onClick={() => handleSort("Α' τρίμηνο 2025 (€/τμ)")}>Α' τρίμηνο 2025 (€/τμ)</th>
                                                <th className="sortable" onClick={() => handleSort("Β' τρίμηνο 2024 (€/τμ)")}>Β' τρίμηνο 2024 (€/τμ)</th>
                                                <th className="sortable" onClick={() => handleSort("Α' τρίμηνο 2024 (€/τμ)")}>Α' τρίμηνο 2024 (€/τμ)</th>
                                                <th className="sortable" onClick={() => handleSort("Α' τρίμηνο 2023 (€/τμ)")}>Α' τρίμηνο 2023 (€/τμ)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData && filteredData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item['Περιοχή']}</td>
                                                    <td>{item["Β' τρίμηνο 2025 (€/τμ)"] === 0 ? "-" : item["Β' τρίμηνο 2025 (€/τμ)"]}</td>
                                                    <td>{item["Α' τρίμηνο 2025 (€/τμ)"] === 0 ? "-" : item["Α' τρίμηνο 2025 (€/τμ)"]}</td>
                                                    <td>{item["Β' τρίμηνο 2024 (€/τμ)"] === 0 ? "-" : item["Β' τρίμηνο 2024 (€/τμ)"]}</td>
                                                    <td>{item["Α' τρίμηνο 2024 (€/τμ)"] === 0 ? "-" : item["Α' τρίμηνο 2024 (€/τμ)"]}</td>
                                                    <td>{item["Α' τρίμηνο 2023 (€/τμ)"] === 0 ? "-" : item["Α' τρίμηνο 2023 (€/τμ)"]}</td>
                                                </tr>
                                            ))}
                                        </tbody>    
                                    </Table>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <p>Φόρτωση...</p>
                    )}
                </Container>
            </main>
            <Footer />
        </div>
    );
};

export default RentPrices;